export default {"src":"/_next/static/media/icon-warning-new.d6732782.svg","height":16,"width":16};